// extracted by mini-css-extract-plugin
export var active = "_es-7";
export var blink = "_es-8";
export var dropDownSelector = "_es-4";
export var dropDownWrapper = "_es-3";
export var fakeCursor = "_es-6";
export var fontSizeButton = "_es-9";
export var formQuillEditor = "_es-0";
export var pressed = "_es-a";
export var qlBlank = "_es-1";
export var textFormattingToolbar = "_es-2";
export var textToolbarOption = "_es-5";